import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"

export enum FirstResponderType {
  GESTATIONAL_CARRIER = "GESTATIONAL_CARRIER",
  FERTILITY = "FERTILITY",
  LGBTQ_FAMILY = "LGBTQ_FAMILY",
  ADOPTION = "ADOPTION",
  PREGNANCY = "PREGNANCY",
  CARE_NAVIGATION = "CARE_NAVIGATION"
}

function SetFirstResponderTypeStep({ currentStepName, firstResponderType }): JSX.Element {
  const { updateRoutingInfo } = useRoutingInfo()

  const { setNextStep } = useStateMachine(currentStepName, "")
  useEffect(() => {
    const updateRoutingInfoAsync = async () => {
      await updateRoutingInfo({ firstResponderType: firstResponderType })
    }
    updateRoutingInfoAsync()
    setNextStep(currentStepName, "")
  })
  return <></>
}

function SetCareNavigationFirstResponder(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_CARE_NAVIGATION_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.CARE_NAVIGATION}
    />
  )
}

function SetAdoptionFirstResponder(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_ADOPTION_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.ADOPTION}
    />
  )
}

function SetGestationCarrierFirstResponderStep(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_GESTATIONAL_CARRIER_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.GESTATIONAL_CARRIER}
    />
  )
}

function SetFertilityFirstResponder(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_FERTILITY_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.FERTILITY}
    />
  )
}

function SetLGBTQFamilyFirstResponder(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_LGBTQ_FAMILY_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.LGBTQ_FAMILY}
    />
  )
}

function SetPregnancyFirstResponder(): JSX.Element {
  return (
    <SetFirstResponderTypeStep
      currentStepName={Steps.SET_PREGNANCY_FIRST_RESPONDER}
      firstResponderType={FirstResponderType.PREGNANCY}
    />
  )
}

export {
  SetCareNavigationFirstResponder,
  SetAdoptionFirstResponder,
  SetGestationCarrierFirstResponderStep,
  SetFertilityFirstResponder,
  SetLGBTQFamilyFirstResponder,
  SetPregnancyFirstResponder
}
